// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.styles_stepper__container__itsid {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-self: center;
    margin-bottom: 2rem;
  }
  
  .styles_stepper__label__VflzO {
    position: absolute;
    font-family: "inter";
    font-weight: 700;
    font-size: 0.8rem;
    margin-top: 0.8rem;
  }
  
  .styles_stepper__active__VMgpJ {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    font-weight: 600;
    color: #18316e;
  }

  .styles_btnImport__-BhKK{
    border-color: #18316e !important;
    color: #18316e !important;
    transition: all 0.3s ease !important;
    width: 86% !important;
    &:hover{
      border-color: #18316e !important;
      transform: scale(0.95) !important;
    }
  }

  .styles_info__c9TXb{
    color: #18316e !important;
    cursor: pointer !important;
    margin-left: .3rem !important;
  }

  .styles_info_text__m2TXF{
    font-size: .9rem;
  }`, "",{"version":3,"sources":["webpack://./src/components/CadastroDetalhado/styles.module.css"],"names":[],"mappings":";AACA;IACI,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gCAAgC;IAChC,yBAAyB;IACzB,oCAAoC;IACpC,qBAAqB;IACrB;MACE,gCAAgC;MAChC,iCAAiC;IACnC;EACF;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;EAClB","sourcesContent":["\n.stepper__container {\n    box-sizing: border-box;\n    display: flex;\n    justify-content: center;\n    align-self: center;\n    margin-bottom: 2rem;\n  }\n  \n  .stepper__label {\n    position: absolute;\n    font-family: \"inter\";\n    font-weight: 700;\n    font-size: 0.8rem;\n    margin-top: 0.8rem;\n  }\n  \n  .stepper__active {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 1rem;\n    font-weight: 600;\n    color: #18316e;\n  }\n\n  .btnImport{\n    border-color: #18316e !important;\n    color: #18316e !important;\n    transition: all 0.3s ease !important;\n    width: 86% !important;\n    &:hover{\n      border-color: #18316e !important;\n      transform: scale(0.95) !important;\n    }\n  }\n\n  .info{\n    color: #18316e !important;\n    cursor: pointer !important;\n    margin-left: .3rem !important;\n  }\n\n  .info_text{\n    font-size: .9rem;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepper__container": `styles_stepper__container__itsid`,
	"stepper__label": `styles_stepper__label__VflzO`,
	"stepper__active": `styles_stepper__active__VMgpJ`,
	"btnImport": `styles_btnImport__-BhKK`,
	"info": `styles_info__c9TXb`,
	"info_text": `styles_info_text__m2TXF`
};
export default ___CSS_LOADER_EXPORT___;
